<!-- Split is the half and half component -->
<ng-template [multiViewComponent]="multiViewComponentType.Split" [portfolioCount]="portfolioCount" [breakpoint]="toggleBreakpoint">
	<div class="row full-container" *ngIf="tableDataTab.tableData[0]?.portfolioData?.length; else noDataMsg">
		<dl-display-table
			[ngClass]="tableClassOverride"
			class="table-container"
			[data]="tableDataTab"
			[hideRows]="false"
			[colors]="tableIconColors"
			[columnClassOverride]="columnClassOverride"
			[tableOptions]="tableOptions"
			[striped]="isTableStriped"
			[attr.data-cy]="'dl ' + tableDataTab?.config?.title?.label + ' display table' | slugify"
		></dl-display-table>
		<ng-container *ngIf="chartConfig.length === 1; else multiChartView">
			<bfa-chart
				*ngIf="!hideChart"
				class="chart-container"
				[ngClass]="chartClassOverride"
				[colors]="colors"
				[type]="chartConfig[0].type"
				[name]="chartConfig[0].name"
				[data]="selectedChartTab"
				[hasFullHeight]="chartHeight?.useFullHeight"
				[height]="chartHeight?.chartHeight"
				[customAttributes]="chartConfig[0].customAttributes"
				[attr.data-cy]="'dl ' + selectedChartTab?.config?.title?.label + ' chart' | slugify"
			></bfa-chart>
		</ng-container>
		<ng-template #multiChartView>
			<div [ngClass]="chartClassOverride">
				<ng-container *ngFor="let chart of chartConfig; let index = index">
					<div class="chart-container">
						<bfa-chart
							*ngIf="!hideChart"
							class="chart-container"
							[ngClass]="chartClassOverride"
							[colors]="colors"
							[type]="chartConfig[index].type"
							[name]="chartConfig[index].name"
							[data]="chartDataTabs[index]"
							[hasFullHeight]="chartHeight[index]?.useFullHeight"
							[height]="chartHeight[index]?.chartHeight"
							[customAttributes]="chartConfig[index].customAttributes"
							[attr.data-cy]="'dl ' + chartDataTabs[index]?.config?.title?.label + ' chart' | slugify"
						></bfa-chart>
					</div>
				</ng-container>
			</div>
		</ng-template>
	</div>
</ng-template>

<!-- Not currently used by any components -->
<ng-template [multiViewComponent]="multiViewComponentType.Radio" [portfolioCount]="portfolioCount" [breakpoint]="toggleBreakpoint">
	<div class="row full-container">
		<dl-display-table
			class="col-9"
			[data]="tableDataTab"
			[striped]="isTableStriped"
			[hideRows]="false"
			[colors]="tableIconColors"
			[columnClassOverride]="columnClassOverride"
		></dl-display-table>
		<div class="col-15">
			<div class="button-row">
				<button
					*ngFor="let tab of chartDataTabs; trackByFields: id"
					class="btn"
					[class.btn-primary]="selectedChartTab.id === tab.id"
					[class.btn-tertiary]="selectedChartTab.id !== tab.id"
					(click)="onChartTabClick(tab)"
				>
					{{ tab.id }}
				</button>
			</div>
			<bfa-chart
				*ngIf="!hideChart"
				[data]="selectedChartTab"
				[hasFullHeight]="chartHeight?.useFullHeight"
				[height]="chartHeight?.chartHeight"
				[type]="chartConfig[0].type"
				[name]="chartConfig[0].name"
				[customAttributes]="chartConfig[0].customAttributes"
				[colors]="colors"
			></bfa-chart>
		</div>
	</div>
</ng-template>

<!-- Toggled is the view with the chart-table toggle -->
<ng-template [multiViewComponent]="multiViewComponentType.Toggled" [portfolioCount]="portfolioCount" [breakpoint]="toggleBreakpoint">
	<div class="row condensed-container">
		<div class="col-24 toggle">
			<ac-chart-table-toggle [initialType]="toggleType.Chart" (newToggleStatus)="toggleChange($event)"></ac-chart-table-toggle>
		</div>
		<div class="col-24" *ngIf="componentState === toggleType.Chart">
			<div class="row">
				<div class="col-4" *ngIf="showLegendTableInToggleMode">
					<dl-display-table [data]="tableDataTab" [striped]="isTableStriped" [hideRows]="true" [colors]="tableIconColors"></dl-display-table>
				</div>
				<bfa-chart
					*ngIf="!hideChart"
					class="chart"
					[colors]="colors"
					[ngClass]="chartColClass"
					[type]="chartConfig[0].type"
					[name]="chartConfig[0].name"
					[data]="selectedChartTab"
					[hasFullHeight]="chartHeight?.useFullHeight"
					[height]="chartHeight?.chartHeight"
					[customAttributes]="chartConfig[0].customAttributes"
				></bfa-chart>
			</div>
		</div>
		<div class="col-24" *ngIf="componentState === toggleType.Table">
			<div class="row">
				<div class="col-24">
					<dl-display-table [data]="tableDataTab" [striped]="isTableStriped" [hideRows]="false" [colors]="tableIconColors"></dl-display-table>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<!-- No Data Message -->
<ng-template #noDataMsg>
	<div class="d-flex justify-content-center align-items-center no-data-msg">
		<p dcrHTMLKey="NO_DATA_AVAILABLE_MESSAGE">No Data Available</p>
	</div>
</ng-template>
